// extracted by mini-css-extract-plugin
export default {"cover_card":"Carousel_cover_card__1-42W","cover_caption":"Carousel_cover_caption__zNAci","cover_thumb":"Carousel_cover_thumb__xR60H","mobile_drag":"Carousel_mobile_drag__FIbKQ"};